import { render } from "./LeavePeriod.vue?vue&type=template&id=36501732&scoped=true"
import script from "./LeavePeriod.vue?vue&type=script&lang=js"
export * from "./LeavePeriod.vue?vue&type=script&lang=js"

import "./LeavePeriod.vue?vue&type=style&index=0&id=36501732&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36501732"]])

export default __exports__